var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"page-error"},[_c('h1',[_vm._v("Authenticated Failed")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }